import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authServie = inject(AuthService);
  const router = inject(Router);

  const token = authServie.getToken();
  const user = authServie.getUser();
  if (user && token) {
    return true;
  } else {
    router.navigate(['login']);
    return false;
  }
};
